import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TableHead } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@totalsoft/rocket-ui";
import { StyledHeaderCell, StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsOutputDictionariesTableHead = ({ canWrite, onAdd, isSaved }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <StyledTableRow>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.OutputDictionaries.ReadOnly")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.OutputDictionaries.Parameter")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.OutputDictionaries.Value")}</StyledHeaderCell>
        <StyledHeaderCell align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isSaved || !canWrite} onClick={onAdd}>
            {t("Add")}
          </Button>
        </StyledHeaderCell>
      </StyledTableRow>
    </TableHead>
  );
};

FinancialProductRulesEditDetailsOutputDictionariesTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductRulesEditDetailsOutputDictionariesTableHead;
